export const packageContext = {
  packageName: "@atlassian/people-menu",
  packageVersion: "57.2.1"
};